<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">구분</th>
          <td>
            <div class="item">
              <div class="lft_area" style="width:274px">
                <select name="" id="" class="i_sel" style="width:260px" v-model="notice.categorySeq">
                  <option
                    v-for="category in categoryListForCreate"
                    :value="category.categorySeq"
                  >{{ category.name }}</option>
                </select>
              </div>

              <div class="lft_area divi brd_left">
                <span class="ui_chkbox primary lgray">
                  <input
                    type="checkbox" 
                    name="sort"
                    v-model="notice.topNoticeYn"
                    true-value="Y"
                    false-value="N"
                  >
                  <label for="">
                    <span class="txt noti">중요 상단공지</span>
                  </label>
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">제목</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="제목을 입력하세요." v-model="notice.title">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">내용</th>
          <td>
            <div class="item">
              <textarea name="" id="" cols="30" rows="9" class="i_ta type_full lineless" placeholder="상세내용을 입력하세요." v-model="notice.content"></textarea>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">첨부파일</th>
          <td>
            <div class="item item_attach">
              <p class="note">(확장자는 jpg, pdf, doc, ppt, hwp, zip 만 가능합니다.)</p>
              <div class="ui_attach" v-for="(row, index) in files" :key="index">
                <input type="text" class="i_txt i_file" v-model="row.originalName" @click="triggerFileInput(index)" readonly>
                <button type="button" class="bt_base primary btn_attach" @click="triggerFileInput(index)"> 찾아보기 </button>
                <button type="button" class="bt_base gray type_ico" @click="removeRow(index)" style="margin-right:5px"> &minus; </button>
                <button type="button" class="bt_base gray type_ico" @click="addRow" v-if="index == 0" > &plus; </button>
                <input type="file" name="file" class="i_upload" ref="file" style="display: none" @change="handleFileChange(index)">
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="lft_area">
      <a class="bt_base gray large_h btn_list" @click="toList">목록</a>
    </div>

    <div class="rgt_area">
      <button type="button" class="bt_base gray large_h" @click=editNotice>수정</button>
      <button type="reset" class="bt_base gray large_h">삭제</button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
const adminNoticeModule = 'adminNoticeModule'
const adminCategoryModule = 'adminCategoryModule'

export default {
  props: {
    noticeSeq: {
      type: String,
      required: true
    }
  },
  data (){
    return {
      files: [{}],
      deletedFileSeqs: [],
    }
  },
  methods: {
    ...mapActions(adminNoticeModule, [
      'requestNotice',
      'requestNoticeEdit',
    ]),

    ...mapActions(adminCategoryModule, [
      'requestCategoryListForCreate'
    ]),

    triggerFileInput(index) {
      const fileInputs = this.$refs.file;
      if (fileInputs && fileInputs[index]) {
        fileInputs[index].click();
      }
    },

    addRow() {
      this.files.push({});
    },

    removeRow(index) {
      const file = this.files[index];

      if (file?.noticeAttachSeq) this.deletedFileSeqs.push(file.noticeAttachSeq);

      if (this.files.length > 1) {
        this.files.splice(index, 1);
      } else {
        this.files = [{}];
      }
    },

    handleFileChange (i) {
      if (this.files[i].noticeAttachSeq) this.deletedFileSeqs.push(this.files[i].noticeAttachSeq);

      const file = this.$refs.file[i].files[0];
      if (file) {
        this.files[i].file = file;
        this.files[i].originalName = file.name;
      }
    },

    toList () {
      this.$router.push({ name: "BoardNoticeManageListPage" })
    },

    async editNotice() {
      const formData = new FormData();
      const content = this.notice.content.replace(/\n/g, '<br>')
      formData.append('noticeSeq', this.notice.noticeSeq);
      formData.append('title', this.notice.title);
      formData.append('content', content);
      formData.append('topNoticeYn', this.notice.topNoticeYn);
      formData.append('categorySeq', this.notice.categorySeq);
      formData.append('deletedFileSeqs', this.deletedFileSeqs);

      this.files.forEach((file) => {
        if(file.file) formData.append('files', file.file);
      });

      if (await this.requestNoticeEdit(formData)) {
        this.$router.push({ name: "BoardNoticeManageListPage" })
      }
    }
  },

  computed: {
    ...mapState(adminNoticeModule, [
      'notice',
    ]),
    ...mapState(adminCategoryModule, [
      'categoryListForCreate'
    ])
  },

  async mounted () {
    await this.requestNotice(this.noticeSeq)
    this.files = this.notice.attachList;
    if(this.files.length == 0) this.files.push({});
    this.notice.content = this.notice.content.replace(/<br\s*\/?>/g, `\n`)

    this.requestCategoryListForCreate('공지사항')
  }
}
</script>
<style lang="">
    
</style>